import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useInputText } from '@/hooks';
import { Validation } from '@/models';

import {
  AlertBox,
  Input,
  InputGroup,
  InputSelectCreatable,
  Loader,
} from '@/components';

import { InfoCircleOutlined } from '@ant-design/icons';
import parse from 'html-react-parser';

import styles from './TransactionReceivers.module.sass';

interface TransactionReceiversProps {
  loading: boolean;
  receivers: string[];
  onChange: (value: string) => void;
  receiverInvalid: boolean;
  valueDefault?: string;
}

const TransactionReceivers: FC<TransactionReceiversProps> = (props) => {
  const { loading, receivers, onChange, receiverInvalid, valueDefault } = props;
  const { t } = useTranslation();
  const RECEIVER_VALIDATIONS: Validation[] = useMemo(() => [], []);
  const options = useMemo(() => {
    return receivers.map((address) => ({ value: address, label: address }));
  }, [receivers]);
  const defaultReceiver = !!valueDefault
    ? { value: valueDefault, label: valueDefault }
    : undefined;
  const receiverField = useInputText('', RECEIVER_VALIDATIONS);
  const handleChange = (val: string) => {
    receiverField.onChange(val);
    onChange(val);
  };

  if (loading) {
    return <Loader />;
  }

  const receiversMissing = receivers.length === 0;

  return (
    <InputGroup>
      <AlertBox type="info" className={styles.info}>
        {{
          description: parse(t('translation.check_addr_string')),
          icon: <InfoCircleOutlined />,
        }}
      </AlertBox>
      {receiversMissing && (
        <Input
          id="receiver"
          name="receiver"
          type="text"
          placeholder={t('translation.check_addr_string') || ''}
          value={receiverField.value}
          onBlur={() => {}}
          onChange={handleChange}
        />
      )}

      {!receiversMissing && (
        <InputSelectCreatable
          id="receiver"
          name="receiver"
          classNamePrefix="chain-select"
          value={receiverField.value}
          options={options}
          onChange={handleChange}
          onBlur={() => {}}
          isError={receiverField.isDirty && !receiverField.isValid}
          valueDefault={defaultReceiver}
          required
          isSearchable
          clearable
        />
      )}
      {receiverInvalid && (
        <AlertBox type="warning" className={styles.error}>
          {{
            description: parse(t('translation.tx_receiver_invalid')),
          }}
        </AlertBox>
      )}
    </InputGroup>
  );
};

export default TransactionReceivers;
